// First Created - 19 May 2025
// Author - Atul Pandey
// Updated - 20 May 2025 - Added All Day segment
// Updated - 23 May 2025 - Refined All Day segment

const segmentGuideMap = {
  early_morning: {
    label: "Early Morning",
    prompt: "Let’s set you up to own the day ahead!",
    nudges: [
      "Review upcoming meetings",
      "Clear your action backlog",
      "Reflect on yesterday’s conversations",
      "Capture fresh thoughts or blog ideas"
    ],
  },
  morning: {
    label: "Morning",
    prompt: "Let’s power you up for a focused start!",
    nudges: [
      "Review your Mission Performance",
      "Stay energized with morning habits",
      "Revisit prep for your next meeting",
      // "Set 2–3 priorities for today’s sessions",
      
    ],
  },
  mid_day: {
    label: "Mid Day",
    prompt: "Let’s capture your conversations and move things forward.",
    nudges: [
      "Log conversations from earlier meetings",
      "Add any follow-up action items",
      // "Sync thoughts from team/client check-ins",
      "Review your Vision & missions",
    ],
  },
  evening: {
    label: "Evening",
    prompt: "Time to celebrate what you accomplished today!",
    nudges: [
      "Review actions completed",
      "Celebrate your wins and contributions",
      "Reflect on what energized you today"
    ],
  },
  night: {
    label: "Night",
    prompt: "Let’s close the loop and prepare for tomorrow.",
    nudges: [
      "Preview meetings for tomorrow",
      "Send gratitude notes to clients or team",
      // "Capture any lingering challenges or intentions"
    ],
  },
};

// ✅ Now safely construct timeSegmentGuides with allDay at the end
export const timeSegmentGuides = {
  ...segmentGuideMap,
  allDay: {
    label: "All",
    // prompt: "Explore your full-day prompts to guide your Trinity journey.",
    prompt: "Would you like Trinity to help you....",
    nudges: [
      ...segmentGuideMap.early_morning.nudges,
      ...segmentGuideMap.morning.nudges,
      ...segmentGuideMap.mid_day.nudges,
      ...segmentGuideMap.evening.nudges,
      ...segmentGuideMap.night.nudges,
      // Refined - 23 May 2025
      // "Reflect on yesterday’s insights",
      // "Capture fresh thoughts or blog ideas",
      // "Stay energized with morning habits",
      // "Review upcoming meetings for today",
      // "Clear your action backlog",
      // "Log conversations from earlier meetings",
      // "Add any follow-up action items",
      // "Set up or refine your vision & missions",
      // "Review actions completed",
      // "Celebrate your wins and contributions",
      // "Review your Mission Performance",
      // "Preview meetings for tomorrow",
      // "Capture any lingering challenges or intentions",
      // "Send gratitude notes to those who made your day!",
    ],
  },
};